
import { INotificationService } from '../../../../../../core/notificationservice';
import '../services/materialTypeService';
import { IMaterialTypeService } from '../services/materialTypeService';
import '../../../../../../core/directives/readOnlyText/readOnlyTextDirective';
import { MaterialType } from '../models/materialType';
import { RequestMaterials } from '../../../models/requestMaterials';
import { RequestAssignedMaterialToPackage } from '../../../models/requestAssignedMaterialToPackage';
import { RequestDetailEdit } from '../../../models/requestDetailEdit';
import { RequestMaterial } from '../../../models/requestMaterial';
import { ICountryService } from '../../../../requestList/services/countryService';
import { Country } from '../../../../requestList/models/country';
import '../templates/materialDialog.scss';
import { RequestPackages } from '../../../models/requestPackages';
import { IPackageTypeService } from '../../packagedialog/services/packageTypeService';
import { PackageType } from '../../packagedialog/models/packageType';




export default class MaterialDialogController {

    static $inject = ['$mdDialog', 'materialTypeService', 'countryService', 'packageTypeService', '$q', 'NotificationService'];
	private _materialTypesList: MaterialType[];
	selectedMaterialType: MaterialType;
	newRequestMaterials: RequestMaterials;
    requestDetailEdit: RequestDetailEdit;
    newRequestPackages: RequestPackages;
	isNewMaterial: boolean;
	isLoading: boolean;
	editIndex: number;
    _countries: Country[];
    private _packageTypesList: PackageType[];

    showAdditionalFields: boolean = false;

    private _previousMaterialType: string;

    get previousMaterialType(): string {
        return this._previousMaterialType;
    }
    set previousMaterialType(value: string) {
        this._previousMaterialType = value;
    }

    constructor(private _$mdDialog: ng.material.IDialogService,
		private _materialTypeService: IMaterialTypeService,
        private _countryService: ICountryService,
        private _packageTypeService: IPackageTypeService,
        private $q: ng.IQService,
        private _notificationService: INotificationService
	) {

	}

	$onInit(): void {
		if (this.isNewMaterial === false) {
			this.newRequestMaterials = angular.copy(this.requestDetailEdit.requestMaterial
                .requestMaterials[this.editIndex]);
            this._previousMaterialType = this.requestDetailEdit.requestMaterial.requestMaterials[this.editIndex].description;
			if (this.newRequestMaterials.materialTypeId !== undefined &&
				this.newRequestMaterials.materialTypeId !== null) {
				this.selectedMaterialType = new MaterialType(this.newRequestMaterials.materialTypeId,
					this.newRequestMaterials.materialDesc,
					this.newRequestMaterials.description);
			}
		}

        this.isLoading = true;
		this.populateInitialValues();
	}

	set isAsset(val: boolean) { }

	get isAsset(): boolean {

		if (this.requestDetailEdit !== undefined &&
			this.requestDetailEdit.requestDetail !== undefined &&
			this.requestDetailEdit.requestDetail.requestShipment !== undefined &&
			this.requestDetailEdit.requestDetail.requestShipment.isAsset) {
			return true;
		}
		return false;
	}

	populateInitialValues(): void {
		const deferred = this.$q.defer();

        this.$q.all([this.populateMaterialTypes(), this.populateCountries(), this.populatePackageTypes()])
            .then((values) => {

                this.handleGetMaterialTypes(values[0]);
                this.handleGetCountries(values[1]);
                this.handleGetPackageTypes(values[2]);
                this.isLoading = false;
            })
            .catch((response) => {
                deferred.reject(this.getErrorReason(response.status));
                this.isLoading = false;
            });

    }

    private populatePackageTypes(): ng.IPromise<PackageType[]> {
        const deferred = this.$q.defer<PackageType[]>();
        this._packageTypeService.getPackageTypes()
            .then((packageTypes) => {
                deferred.resolve(packageTypes);
            })
            .catch((response) => {
                deferred.reject(response);
            });
        return deferred.promise;
    }

    handleGetPackageTypes(options: any) {
        this._packageTypesList = options;
    }


	private populateMaterialTypes(): ng.IPromise<MaterialType[]> {
        const deferred = this.$q.defer<MaterialType[]>();
        this._materialTypeService.getMaterialTypes()
            .then((materialTypes) => {
                deferred.resolve(materialTypes);
            })
            .catch((response) => {
                deferred.reject(response);
            });
		return deferred.promise;
	}

	private populateCountries(): ng.IPromise<Country[]> {
        const deferred = this.$q.defer<Country[]>();
        this._countryService.getCountryList()
            .then((countries) => {
                deferred.resolve(countries);
            })
            .catch((response) => {
                deferred.reject(response);
            });
		return deferred.promise;
	}

	private getErrorReason(status: any): string {
		var value = 'error';
		if (status !== undefined && status.toString() === "401")
			value = 'timeout';
		return value;
	}


	showAdditionalFieldsClick(val: boolean): void {
		this.showAdditionalFields = val;
	}

	handleGetMaterialTypes(options: any) {
		this._materialTypesList = options;
	}

	handleGetCountries(options: any) {
		this._countries = options;
	}

	handleCountryOpen(): void {
		this.newRequestMaterials.country = undefined;
	}

	handleOptionalCountryOpen(): void {
		this.newRequestMaterials.manufactureCountryCode = undefined;
	}

	get materialTypeList(): Array<MaterialType> {
		return this._materialTypesList;
	}

	get countries(): Country[] {
		return this._countries;
	}

	getTotal(quantity: number, costPerUnit: number): string {
		if (quantity !== undefined && quantity !== null && costPerUnit !== undefined && costPerUnit !== null) {
			var total = quantity * costPerUnit;
			this.newRequestMaterials.total = Number(total.toFixed(2));
			return '$' + total.toFixed(2);
		} else {
			return '';
		}
    }

    getTotalNetWeight(quantity: number, netWeight: number): string {
        if (quantity !== undefined && quantity !== null && netWeight !== undefined && netWeight !== null) {
            var total = quantity * netWeight;
            this.newRequestMaterials.total = Number(total.toFixed(2));
            return parseFloat(total.toFixed(5)).toString();
        } else {
            return '';
        }
    }

	cancel(): void {
		this._$mdDialog.cancel();
	}

    save(): void {
		this._$mdDialog.hide();
		if (this.isNewMaterial === false) {
			this.newRequestMaterials.recordNumber = this.editIndex;
			this.requestDetailEdit.requestMaterial.requestMaterials[this.editIndex] = angular
				.copy(this.newRequestMaterials);

			this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[this.editIndex]
                .requestMaterials = angular.copy(this.newRequestMaterials);
            
		} else {

			if (this.requestDetailEdit !== undefined &&
				this.requestDetailEdit.requestMaterial !== undefined &&
				this.requestDetailEdit.requestMaterial.requestMaterials.length > 0) {
				const nextIndex = this.requestDetailEdit.requestMaterial.requestMaterials.length;
				this.newRequestMaterials.recordNumber = angular.copy(this
					.findNextRecordNumberForMaterials(angular.copy(this.requestDetailEdit)));
				this.requestDetailEdit.requestMaterial.requestMaterials[nextIndex] = angular.copy(this.newRequestMaterials);

				this.loadMaterialsToAssignMaterialsOnSave(nextIndex, angular.copy(this.newRequestMaterials));


			} else {
				this.newRequestMaterials.recordNumber = 0;
				this.requestDetailEdit.requestMaterial.requestMaterials[0] = angular.copy(this.newRequestMaterials);
				this.loadMaterialsToAssignMaterialsOnSave(0, angular.copy(this.newRequestMaterials));
			}
		}
		if (this.newRequestMaterials.materialDesc == 'Documents') {
			this.applyEnvelopePackaging();
		}
		else {
			this.newRequestPackages = new RequestPackages(undefined);
			this.requestDetailEdit.requestMaterial.requestPackages = [];
		}
		this.loadPackagesToAssignMaterialsOnSave(angular.copy(0), angular.copy(this.newRequestPackages));
	}

	private applyEnvelopePackaging() {
		var packageTypeId = this._packageTypesList.filter(x => x.description === "Envelope")[0].packageTypeId;
		this.newRequestPackages = new RequestPackages(undefined);
		this.newRequestPackages.packageTypeId = packageTypeId;
		this.newRequestPackages.packageType = "Envelope";
		this.newRequestPackages.grossWeight = .5;

		this.newRequestPackages.recordNumber = 0;
		this.requestDetailEdit.requestMaterial.requestPackages[0] = angular.copy(this.newRequestPackages);
		
    }

	private findNextRecordNumberForMaterials(requestDetailEdit: RequestDetailEdit): number {
		var nextMaterialRecordNumber: number = 0;
		if (requestDetailEdit !== undefined &&
			requestDetailEdit.requestMaterial !== undefined &&
			requestDetailEdit.requestMaterial.requestMaterials.length > 0) {

			for (var eachRequestMaterial of requestDetailEdit.requestMaterial.requestMaterials) {
				if (nextMaterialRecordNumber <= eachRequestMaterial.recordNumber) {
					nextMaterialRecordNumber = angular.copy(eachRequestMaterial.recordNumber);
				}
			}
		}
		return nextMaterialRecordNumber + 1;
	}

	

	private loadMaterialsToAssignMaterialsOnSave(materialEditIndex: number, rqMaterials: RequestMaterials) {

		var newRequestAssignToMaterials = new RequestAssignedMaterialToPackage(undefined);
		newRequestAssignToMaterials.requestMaterials = angular.copy(rqMaterials);
		if (newRequestAssignToMaterials
			.requestPackages ===
			undefined ||
			newRequestAssignToMaterials.requestPackages === null) {
			newRequestAssignToMaterials.requestPackages = [];
		}
		newRequestAssignToMaterials.requestPackages = angular.copy(this.requestDetailEdit.requestMaterial.requestPackages);
		this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[materialEditIndex] = angular
			.copy(newRequestAssignToMaterials);
	}

    materialTypeChanged(): void {
        if (this.newRequestMaterials === undefined || this.newRequestMaterials === null) {
            this.newRequestMaterials = new RequestMaterials(undefined);
        }
        this.newRequestMaterials.materialTypeId = this.selectedMaterialType.materialTypeId;
        this.newRequestMaterials.materialDesc = this._materialTypesList
            .filter(x => x.materialTypeId === this.selectedMaterialType.materialTypeId)[0].description;
        this.newRequestMaterials.description = this._materialTypesList
            .filter(x => x.materialTypeId === this.selectedMaterialType.materialTypeId)[0].description2;
        if (this.newRequestMaterials.materialDesc !== 'Documents') {
            if (this._previousMaterialType === 'Documents') {
                this.newRequestMaterials.quantity = undefined;
                this.newRequestMaterials.netWeight = undefined;
                this.newRequestMaterials.costPerUnit = undefined;
                this.newRequestMaterials.country = undefined;
            }
        } else {
            if ((this.isNewMaterial === true && this.requestDetailEdit.requestMaterial.requestMaterials.length == 0) || (this.isNewMaterial === false && this.requestDetailEdit.requestMaterial.requestMaterials.length == 1)) {
                this.newRequestMaterials.quantity = 1;
                this.newRequestMaterials.netWeight = .5;
                this.newRequestMaterials.costPerUnit = 1;
                var countryIdDoc = this.countries
                    .filter(x => x.countryName === 'USA')[0].countryCode;
                this.newRequestMaterials.country = countryIdDoc;
            }
            else {
                this.newRequestMaterials.materialTypeId = undefined;
                this.newRequestMaterials.materialDesc = undefined;
                this.newRequestMaterials.description = undefined;
                this.selectedMaterialType.materialTypeId = undefined;
                this._notificationService
                    .showToastWithMentionedDelay("Please delete existing Material(s) from shipment request to add Document type material",
                    5000);
            }
        }
    }

    private loadPackagesToAssignMaterialsOnSave(packageEditIndex: number, rqPackage: RequestPackages) {
        for (var i = 0; i < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; i++) {
            if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages === undefined ||
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages === null) {
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages = [];
            }
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i]
                .requestPackages[packageEditIndex] = angular.copy(rqPackage);

            this.calculateAssignedPcOfAssignedMaterials();

        }
    }

    private calculateAssignedPcOfAssignedMaterials() {
        for (var iam = 0; iam < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iam++) {
            if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam] !== undefined &&
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials !==
                undefined &&
                !this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials
                    .isDeleted) {
                var assignedPc = 0;
                for (let assignedMaterialRequestPackage of this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestPackages.filter(o => !o.isDeleted)) {

                    assignedPc = assignedPc + (assignedMaterialRequestPackage.quantity !== undefined && assignedMaterialRequestPackage.quantity !== null ?
                        assignedMaterialRequestPackage.quantity : 0);
                }

                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].assignedPc = angular
                    .copy(assignedPc);
            }
        }
    }

	shouldDisableSave(): boolean {
		return false;
	}

}

angular
	.module('deliveryCreate.app')
	.component('materialDialog',
	{
		template: require('../templates/materialDialog.html'),
		controller: MaterialDialogController,
		controllerAs: 'vm',
		bindings: {
			requestDetailEdit: '=',
			isNewMaterial: '=',
			editIndex: '='

		}
	});


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/materialDialog/controllers/materialDialogController.ts
 **/